import { render, staticRenderFns } from "./ConcludedOnboarding.vue?vue&type=template&id=2b45aea4&scoped=true"
import script from "./ConcludedOnboarding.vue?vue&type=script&lang=js"
export * from "./ConcludedOnboarding.vue?vue&type=script&lang=js"
import style0 from "./ConcludedOnboarding.vue?vue&type=style&index=0&id=2b45aea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45aea4",
  null
  
)

export default component.exports